export const BASE_URL = 'http://localhost:5005';
// export const BASE_URL = 'https://lsu-tech-web-server-dev.herokuapp.com';
